import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { UsersThree, Warning, EnvelopeSimple } from "@phosphor-icons/react";
import api from "@/lib/api";
import { t } from "@/lib/i18n";

export default function JoinPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/team/invite-info/${token}`).then((r) => setInfo(r.data)).catch(() => setError(true));
  }, [token]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="bg-white border border-gray-200 rounded-md p-10 max-w-md w-full text-center" data-testid="join-page">
        <div className="flex items-center gap-2 mb-6 justify-center">
          <div className="w-9 h-9 rounded-md bg-blue-600 flex items-center justify-center">
            <EnvelopeSimple size={20} weight="bold" className="text-white" />
          </div>
          <span className="font-heading font-bold text-xl text-gray-900">Agentic Inbox</span>
        </div>
        {error && (
          <>
            <Warning size={40} weight="fill" className="text-amber-500 mx-auto mb-3" />
            <h1 className="font-heading text-xl font-bold text-gray-900 mb-2">{t("join.invite_notfound", "Invitation not found")}</h1>
            <p data-testid="join-invalid" className="text-sm text-gray-500">{t("join.invite_invalid", "This invite link is invalid. Ask your team admin to send a new one.")}</p>
          </>
        )}
        {info && !info.valid && (
          <>
            <Warning size={40} weight="fill" className="text-amber-500 mx-auto mb-3" />
            <h1 className="font-heading text-xl font-bold text-gray-900 mb-2">Invitation {info.status === "accepted" ? "already used" : "expired"}</h1>
            <p data-testid="join-invalid" className="text-sm text-gray-500">Ask your team admin at {info.team_name} for a new invite.</p>
          </>
        )}
        {info && info.valid && (
          <>
            <UsersThree size={40} className="text-blue-600 mx-auto mb-3" />
            <h1 className="font-heading text-xl font-bold text-gray-900 mb-1">Join {info.team_name}</h1>
            <p data-testid="join-team-info" className="text-sm text-gray-600 mb-6">
              <span className="font-medium">{info.invited_by}</span> invited <span className="font-medium">{info.email}</span> to their team.
            </p>
            <button data-testid="join-accept-btn" onClick={() => navigate(`/login?email=${encodeURIComponent(info.email)}&invited=1`)}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-md py-3 text-sm transition-colors">
              Accept & sign in with {info.email}
            </button>
            <p className="text-xs text-gray-400 mt-3">{t("join.verify_note", "You'll verify this email with a one-time code — no password needed.")}</p>
          </>
        )}
        {!info && !error && <p className="text-sm text-gray-400">{t("join.loading_invite", "Loading invitation…")}</p>}
      </div>
    </div>
  );
}
